var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON STORY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4175 3.38545C15.4175 3.38545 21.1335 0.661586 25.7947 3.15788C26.2958 6.39291 25.9463 18.4228 25.9463 18.4228C25.9463 18.4228 19.7292 17.2324 15.467 18.1392C15.4175 15.1877 15.4175 3.38545 15.4175 3.38545Z",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4363 18.1948C11.174 17.288 4.95696 18.4784 4.95696 18.4784C4.95696 18.4784 4.60744 6.44858 5.10852 3.21355C9.76977 0.71725 15.4858 3.44112 15.4858 3.44112",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.1476 4.91553C26.1476 4.91553 28.053 5.42669 29.0056 6.44902C28.9562 7.92299 28.7056 21.5458 28.7056 21.5458C28.7056 21.5458 18.6655 18.4824 15.4395 18.1988",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.85799 4.91553C4.85799 4.91553 2.95266 5.42669 2 6.44902C2.04949 7.92299 2.30003 21.5458 2.30003 21.5458C2.30003 21.5458 12.3401 18.4824 15.5662 18.1988",
    stroke: "#EF7056",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.1b6b7384b2555da5970b9695e6ed75f7.svg";
export { ForwardRef as ReactComponent };